import React from "react";

const Section_7 = () => {
  return (
    <div className="js-show-on-scroll xl:px-[5rem] w-[100vw] xl:mt-10 xl:p-0 p-5 ">
      <div className=" grid xl:grid-cols-3 xl:gap-10">
        <div className=" w-full col-span-2">
          <img
            src="https://acclime.com/wp-content/uploads/location-map-Acclime.svg"
            alt=""
          />
        </div>
        <div className=" grid content-center text-[#00263e]">
          <h2 className=" text-lg">Regional expansion</h2>
          <h1 className=" xl:text-5xl text-4xl font-bold mt-3 text-ellipsis">
            Expand & operate across Asia under one invoice.
          </h1>
          <p className="xl:mt-10 mt-5 font-sm">
            Thanks to our on-the-ground presence in Asia’s hard-to-navigate
            markets and a secure client platform, you can expand your Thailand
            business into other markets in Asia with ease and confidence. Your
            relationship manager will coordinate all we do for you, across every
            market. We can even combine everything under one invoice.
          </p>
          <div className="w-full">
            <button className="mt-5 min-w-[180px] h-[45px] text-center rounded-full text-[#fe8200] bg-white border-[#fe8200] border-[2px] text-[16px] transition delay-100 ease-in hover:bg-[#fe8200] hover:text-white">
              View all locations
            </button>
            <span className="ml-5 text-[16px] border-b-2 border-[#00263e] cursor-pointer hover:text-[#fe8200] hover:border-[#fe8200]">
              Explore solution
            </span>
          </div>
        </div>
      </div>
      <div className="grid xl:grid-cols-4 grid-cols-2 text-[#00263e] my-10">
        <div>
          <h1 className=" xl:text-6xl text-4xl font-bold">11</h1>
          <p className=" xl:text-lg font-medium">Markets in Asia</p>
        </div>
        <div>
          <h1 className=" xl:text-6xl text-4xl font-bold">3</h1>
          <p className=" xl:text-lg font-medium">Global client centres</p>
        </div>
        <div>
          <h1 className=" xl:text-6xl text-4xl font-bold">9,500+</h1>
          <p className=" xl:text-lg font-medium">Active clients</p>
        </div>
        <div>
          <h1 className=" xl:text-6xl text-4xl font-bold">950+</h1>
          <p className=" xl:text-lg font-medium">Employees</p>
        </div>
      </div>
    </div>
  );
};

export default Section_7;
